<p-table
  #dt
  aria-label="Service Lines Table"
  currentPageReportTemplate="Showing {first}-{last} of {totalRecords} items"
  dataKey="serviceLineId"
  paginatorDropdownAppendTo="body"
  responsiveLayout="scroll"
  selectionMode="multiple"
  sortField="lineNumber"
  sortOrder="-1"
  [alwaysShowPaginator]="true"
  [columns]="columnConfig"
  [paginator]="true"
  [rows]="10"
  [rowsPerPageOptions]="[10, 25, 50]"
  [scrollable]="true"
  [selection]="selection"
  [showCurrentPageReport]="true"
  [value]="tableData"
  (selectionChange)="selectionChange($event)"
>
  <ng-template let-columns pTemplate="header">
    <tr class="py-1">
      <th
        class="flex items-center justify-center"
        style="width: 3.5rem"
      >
        <p-tableHeaderCheckbox />
      </th>
      @for (col of columns; track col.field) {
        <th
          [pSortableColumn]="col.field"
          [pSortableColumnDisabled]="!col.isSortable"
          [style]="col.styles"
        >
          <div class="flex items-center">
            {{ col.header }}
            @if (col.isSortable) {
              <p-sortIcon [field]="col.field"/>
            }
          </div>
        </th>
      }
    </tr>
    <tr>
      <th style="width: 3.5rem"></th>
      @for (col of columns; track col.field) {
        <th [style]="col.styles">
          @switch (col.filterTemplate) {
            @case ('multiSelectFilterTemplate') {
              <p-columnFilter
                matchMode="in"
                [field]="col.field"
                [showClearButton]="false"
                [showMenu]="false"
              >
                <ng-template
                  let-filter="filterCallback"
                  let-value
                  pTemplate="filter"
                >
                  <p-multiSelect
                    appendTo="body"
                    placeholder="Filter"
                    styleClass="p-column-filter"
                    [ngModel]="value"
                    [options]="col.filterList"
                    (onChange)="filter($event.value)"
                  >
                  </p-multiSelect>
                </ng-template>
              </p-columnFilter>
            }
            @case ('textFilterTemplate') {
              <p-columnFilter
                matchMode="contains"
                [field]="col.field"
                [showClearButton]="false"
                [showMenu]="false"
              >
                <ng-template
                  let-filter="filterCallback"
                  let-value
                  pTemplate="filter"
                >
                  <input
                    pInputText
                    placeholder="Search"
                    [ngModel]="value"
                    (input)="filter($event.target.value)"
                  />
                </ng-template>
              </p-columnFilter>
            }
            @default {
            }
          }
        </th>
      }
    </tr>
  </ng-template>
  <ng-template let-columns="columns" let-rowData pTemplate="body">
    <tr [pSelectableRow]="rowData">
      <td style="width: 3.5rem">
        <p-tableCheckbox [value]="rowData" (click)="$event.stopPropagation()"/>
      </td>
      @for (col of columns; track $index) {
        <td>
          @switch (col.field) {
            @case ('requestReceivedDate') {
              {{
                rowData[col.field]
                  | date : "MM/dd/yyyy hh:mm:ss a"
                  | emptyPlaceholder
              }}
            }
            @case ('effectiveFrom') {
              {{
                rowData[col.field] | utcDateWithoutTimeZone : "MM/dd/yyyy" || "-"
              }}
            }
            @case ('effectiveThrough') {
              {{
                rowData[col.field] | utcDateWithoutTimeZone : "MM/dd/yyyy" || "-"
              }}
            }
            @default {
              {{ rowData[col.field] }}
            }
          }
        </td>
      }
    </tr>
  </ng-template>
  <ng-template let-columns pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="columns.length + 1">No records found.</td>
    </tr>
  </ng-template>
  <ng-template pTemplate="paginatorleft">
    <!-- empty but allows paginator to be pushed to the right -->
  </ng-template>
</p-table>
